import { Point } from 'ol/geom';
import { IGeometry, IGeometryCollection } from 'types/omjs/project';

// eslint-disable-next-line max-len
const loaderIconSrc = 'data:image/png;base64,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';

export interface ISysLayer {
    layer: any,
    source: any,
    polyLayer: any,
    polySource: any,
    showLoader: (geom: Point | [ number, number ]) => ISysLayer,
    hideLoader: () => ISysLayer,
    show: () => ISysLayer,
    hide: () => ISysLayer,
    clear: () => ISysLayer,
    clearPoly: () => ISysLayer,
    addFeature: (obj: any) => void,
    addGeometry: (geom: IGeometry) => void
    removeGeometry: () => void
}

export default (view: omjs.View): ISysLayer => {
    const polySource = new omjs.ol.source.Vector({});
    const polyLayer = new omjs.View.VectorLayer({});
    // Устанавливаем стили подсветки на слой
    polyLayer.getMapLayer().setStyle(new omjs.ol.style.Style({
        fill: new omjs.ol.style.Fill({
            color: 'rgba(255,255,0,0.4)'
        }),
        image: new omjs.ol.style.Circle({
            fill: new omjs.ol.style.Fill({
                color: 'rgba(255,255,0,0.4)'
            }),
            radius: 10
        })
    }));
    polyLayer.setSource(polySource);
    polyLayer.getMapLayer().setZIndex(9999999);

    view.addLayer(polyLayer);
    polyLayer.hide();

    const preloadSource = new omjs.ol.source.Vector({});
    const preloadLayer = new omjs.View.VectorLayer({});
    preloadLayer.getMapLayer().setZIndex(9999999);
    preloadLayer.setSource(preloadSource);
    view.addLayer(preloadLayer);
    preloadLayer.hide();

    const preloadFeature = new omjs.ol.Feature();
    const iconImg = new Image();
    iconImg.src = loaderIconSrc;
    iconImg.width = 60;
    iconImg.height = 60;
    const icon = new omjs.ol.style.Icon({
        img: iconImg,
        imgSize: [ 60, 60 ],
        size: [ 60, 60 ]
    });

    const style = new omjs.ol.style.Style({
        image: icon
    });

    preloadFeature.setStyle(style);
    preloadFeature.setId('_system_preload_feature');

    preloadFeature.stopAnimation = function() {};
    preloadFeature.animate = function() {
        preloadFeature.stopAnimation();
        icon.setRotation(0);
        preloadFeature.stopAnimation = omjs['Utils'].animate({
            duration: 1000,
            draw: function(progress) {
                let angle = 6.28 * progress;
                if (angle > 6.28) angle = 0;
                icon.setRotation(angle);
                preloadFeature.setStyle(style);
            },
            infinite: true
        });
    };

    return {
        layer: preloadLayer,
        source: preloadSource,
        polyLayer: polyLayer,
        polySource: polySource,

        showLoader: function(geom) {
            const fId = preloadFeature.getId();
            preloadFeature.animate();
            preloadFeature.setGeometry('length' in geom ? new omjs.ol.geom.Point(geom) : geom);

            if (!preloadSource.getFeatureById(fId)) {
                preloadSource.addFeature(preloadFeature);
            }
            return this;
        },

        hideLoader: function() {
            const fId = preloadFeature.getId();
            preloadFeature.stopAnimation();
            if (preloadSource.getFeatureById(fId)) {
                preloadSource.removeFeature(preloadFeature);
            }
            return this;
        },

        show: function() {
            polyLayer.show();
            preloadLayer.show();
            return this;
        },

        hide: function() {
            polyLayer.hide();
            preloadLayer.hide();
            return this;
        },

        clear: function() {
            preloadFeature.stopAnimation();
            preloadSource.clear();
            polySource.clear();
            return this;
        },

        clearPoly: function() {
            if (this.sysFeature) {
                polySource.removeFeature(this.sysFeature);
            }
            return this;
        },

        addFeature: function(obj: any) {
            polySource.addFeature(obj.feature);
            this.currentObjSyslayer = obj;
        },

        addGeometry: function(geom: IGeometry | IGeometryCollection) {
            let geometry;
            if (geom.type === 'GeometryCollection') {
                geometry = new omjs.ol.geom.GeometryCollection((geom as IGeometryCollection).geometries
                    .map(g => new omjs.ol.geom[g.type](g.coordinates)));
            } else {
                geometry = new omjs.ol.geom[geom.type]((geom as IGeometry).coordinates);
            }
            this.sysFeature = new omjs.ol.Feature({ geometry });
            polySource.addFeature(this.sysFeature);
        },

        removeGeometry() {
            if (this.sysFeature) {
                polySource.removeFeature(this.sysFeature);
                this.sysFeature = null;
            }
        }
    };
};
